import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["ph1", "ph2", "ph3"]
  static values = {
    ph2Data: Array,
    ph3Data: Array
  }

  connect() {
    // Store all available nodes with parent relationships
    this.allPh2Options = this.ph2DataValue
    this.allPh3Options = this.ph3DataValue

    // Listen for changes
    if (this.hasPh1Target) {
      this.ph1Target.addEventListener('change', () => this.filterPh2())
    }
    if (this.hasPh2Target) {
      this.ph2Target.addEventListener('change', () => this.filterPh3())
    }

    // Initial filter
    this.filterPh2()
    this.filterPh3()
  }

  filterPh2() {
    if (!this.hasPh2Target) return

    const ph1Select = this.ph1Target
    const slimPh1 = ph1Select._slim

    if (!slimPh1) return

    const selectedPh1Ids = slimPh1.selected().map(val => parseInt(val)).filter(v => !isNaN(v))

    // Get current PH2 selections
    const slimPh2 = this.ph2Target._slim
    const currentPh2Selections = slimPh2 ? slimPh2.selected().map(val => parseInt(val)).filter(v => !isNaN(v)) : []

    let filteredPh2Options
    if (selectedPh1Ids.length === 0) {
      // No PH1 selected, show all PH2
      filteredPh2Options = this.allPh2Options
    } else {
      // Filter PH2 to only show those whose parent is in selected PH1
      filteredPh2Options = this.allPh2Options.filter(node => {
        return selectedPh1Ids.includes(node.parent_id)
      })
    }

    // Update SlimSelect with filtered options
    if (slimPh2) {
      const options = filteredPh2Options.map(node => ({
        text: node.name,
        value: node.id.toString()
      }))

      slimPh2.setData(options)

      // Restore selections that are still valid
      const validSelections = currentPh2Selections.filter(id =>
        filteredPh2Options.some(node => node.id === id)
      )
      if (validSelections.length > 0) {
        slimPh2.set(validSelections.map(String))
      }
    }

    // After filtering PH2, update PH3
    this.filterPh3()
  }

  filterPh3() {
    if (!this.hasPh3Target) return

    const ph2Select = this.ph2Target
    const slimPh2 = ph2Select._slim

    if (!slimPh2) return

    const selectedPh2Ids = slimPh2.selected().map(val => parseInt(val)).filter(v => !isNaN(v))

    // Get current PH3 selections
    const slimPh3 = this.ph3Target._slim
    const currentPh3Selections = slimPh3 ? slimPh3.selected().map(val => parseInt(val)).filter(v => !isNaN(v)) : []

    let filteredPh3Options
    if (selectedPh2Ids.length === 0) {
      // No PH2 selected, show all PH3
      filteredPh3Options = this.allPh3Options
    } else {
      // Filter PH3 to only show those whose parent is in selected PH2
      filteredPh3Options = this.allPh3Options.filter(node => {
        return selectedPh2Ids.includes(node.parent_id)
      })
    }

    // Update SlimSelect with filtered options
    if (slimPh3) {
      const options = filteredPh3Options.map(node => ({
        text: node.name,
        value: node.id.toString()
      }))

      slimPh3.setData(options)

      // Restore selections that are still valid
      const validSelections = currentPh3Selections.filter(id =>
        filteredPh3Options.some(node => node.id === id)
      )
      if (validSelections.length > 0) {
        slimPh3.set(validSelections.map(String))
      }
    }
  }
}
